import { noop } from './unit';
/**
 * Creates an empty Promise and defers resolving/rejecting it.
 */
export function deferredPromise() {
    let resolve = noop;
    let reject = noop;
    const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    });
    return { promise, resolve, reject };
}
/**
 * Wraps a promise so it can timeout.
 *
 * @param promise
 * @param timeout
 * @param timeoutMsg
 */
export function timedPromise(promise, timeout, timeoutMsg) {
    const timer = new Promise((_, reject) => {
        const timerId = window.setTimeout(() => {
            window.clearTimeout(timerId);
            reject(timeoutMsg);
        }, timeout);
    });
    return Promise.race([promise, timer]);
}
